import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.fullStressLastSendNotificationTime.loading;
export const selectErrorMessage = (state: RootState) =>
  state.fullStressLastSendNotificationTime.error;
export const fullStressLastSendNotificationTimeResponse = (state: RootState) =>
  state.fullStressLastSendNotificationTime
    .fullStressLastSendNotificationTimeResponse;
